import { useCallback } from "react";
import { LocationInput } from "./types";
import { useToast } from "@/hooks/use-toast";
import useCustomAccommodationStore from "@/stores/tripBuilder/useCustomAccommodation";

export const useHandleNext = () => {
  const { toast } = useToast();
  const setCurrentStepIndex = useCustomAccommodationStore(
    (state) => state.setCurrentStepIndex
  );
  const name = useCustomAccommodationStore((state) => state.name);
  const location = useCustomAccommodationStore((state) => state.location);
  const images = useCustomAccommodationStore((state) => state.images);

  const handleNext = useCallback(
    (
      currentStep: number,
      setCurrentStep: (step: number) => void,
      totalSteps: number,
      locationData?: LocationInput
    ) => {
      // Basic validation for required fields
      if (currentStep === 0 && !name.trim()) {
        toast({
          title: "Name required",
          description: "Please enter a name for your property",
          variant: "destructive",
        });
        return;
      }

      if (
        currentStep === 1 &&
        (!location.value.trim() || !location.coordinates)
      ) {
        toast({
          title: "Location required",
          description: "Please select a location for your property",
          variant: "destructive",
        });
        return;
      }

      if (currentStep === totalSteps - 1 && images.length === 0) {
        toast({
          title: "Image required",
          description: "Please add at least one image for your property",
          variant: "destructive",
        });
        return;
      }

      // Update store's current step
      if (currentStep < totalSteps - 1) {
        const nextStep = currentStep + 1;
        setCurrentStep(nextStep);
        setCurrentStepIndex(nextStep);
      }
    },
    [name, location, images, setCurrentStepIndex, toast]
  );

  return { handleNext };
};
